import Footer from "../Footer";
import Logos from "../Logos";
import PluginPageHeader from "../PluginPageHeader";

import Plugin from "../Plugin";
import { Container } from "./styles";
import { useEffect, useState } from "react";
import AssetImg from "../AssetImg";

function PublicPluginDetail({ user, openLogin }) {
  const [theme, setTheme] = useState("sorbet");
  const [themeType, setThemeType] = useState();

  useEffect(() => {
    // this is a rendering race between the main App component, which is also applying a theme.
    // we want a timeout that is long enough to let the App component render, but not so long that the user sees a flash of the wrong theme.
    setTimeout(() => {
      setTheme(document.body.getAttribute("data-theme"));
      setThemeType(document.body.getAttribute("data-theme-type"));
      document.body.setAttribute("data-theme", "sorbet");
      document.body.setAttribute("data-theme-type", "light");
    }, 10);

    return () => {
      if (theme) {
        document.body.setAttribute("data-theme", theme);
      }
      if (themeType) {
        document.body.setAttribute("data-theme-type", themeType);
      }
      // if (bodyObserverRef.current) {
      //   bodyObserverRef.current.disconnect();
      // }
    };
  });

  return (
    <Container>
      <PluginPageHeader openLogin={openLogin} />
      <div className="main">
        <div className="left">
          <Plugin
            openLogin={openLogin}
          />
        </div>
        {!user && (
          <div className="right">
            <div className="sudowrite-explainer">
              <div className="explainer-content">
                <p className="intro">Welcome Dear Author,</p>
                <p>
                  <AssetImg
                    className="sudowrite-banner"
                    src="example-screen.png"
                    alt="Sudowrite Explainer"
                  />
                  <AssetImg
                    className="sudowrite-banner flipped"
                    src="Wormhole-UI-Sample.png"
                    alt="Sudowrite Explainer"
                  />
                  We’re Sudowrite, a company started by authors to put the power of AI in the hands of people like us. We set out to make the writing tool of our dreams. It turns out, it’s something
                  thousands of other authors wanted, too!
                </p>
                <p>
                  Now we’ve made it so <strong>authors can customize Sudowrite to do incredible new things that help with their writing</strong>. They can even share those creations so other writers
                  can benefit. That’s what you’re looking at.
                </p>
                <button onClick={openLogin}>Start a Free Trial</button>
              </div>
            </div>

            <Logos />
          </div>
        )}
      </div>
      <div className="footer-container">
        <Footer />
      </div>
    </Container>
  );
}

export default PublicPluginDetail;
